<template>
  <div class="store-content">
    <div v-for="subItem in arr" :key="subItem.id" clickable @click="handleRadio(subItem)" class="store-item-info" @click.stop="toDetail(subItem)">
      <div v-if="[1, '1', 2].includes(subItem.customerTag) && subItem.imgUrl" class="img-bc">
        <img v-if="subItem.imgUrl" class="custom-img" :src="subItem.imgUrl" alt="" @click.stop="imgPreview(subItem.imgUrl)">
        <img v-else class="custom-img" src="@/assets/images/icon_noimg.png" alt="">
        <img v-if="[1, '1'].includes(subItem.customerTag)" class="mark-img" src="@/assets/images/u93.png" alt="">
      </div>
      <img v-else-if="subItem.imgUrl" class="store-img" :src="subItem.imgUrl" alt="" @click.stop="imgPreview(subItem.imgUrl)">
      <img v-else class="store-img" src="@/assets/images/icon_noimg.png" alt="">
      <div class="right-section">
        <div class="store-name txt-ellipsis">{{ subItem.customerName }}</div>
        <div class="ba-name txt-ellipsis" v-if="subItem.dutyName">{{ $t('shared.bA') }}：{{ subItem.dutyName }}</div>
        <div class="product-type" v-if="subItem.newShelfList.length > 0">
          <div class="type-info txt-ellipsis">
            <span>({{ subItem.newShelfList.length }})</span>
            <span>{{ subItem.newShelfList.join(',') }}</span>
          </div>
        </div>
        <div class="basic-info">
          <span class="city-name txt-ellipsis">{{ subItem.city }}</span>
          <span class="address txt-ellipsis">{{ subItem.address }}</span>
          <img v-if="subItem.lat" class="nav-path-img" src="@/assets/images/daohan1.png" alt="" @click.stop="routePlan(subItem)">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'
export default {
  name: 'Store',
  props: {
    arr: {
      type: Array,
      required: true
    },
    pageType: {
      type: String,
      default: ''
    }
  },
  created () {},
  data () {
    return {
      storeRadio: ''
    }
  },
  methods: {
    routePlan (params) {
      this.$emit('getCurrentLoc', params)
    },
    toDetail (item) {
      this.$router.push(`/storeIncentive?customerId=${item.id}`)
    },
    imgPreview (url) {
      ImagePreview([url])
    },
    handleRadio (params) {
      if (this.storeRadio === params.id) {
        this.storeRadio = ''
      } else {
        this.storeRadio = params.id
      }
      this.$emit('getItemData', this.storeRadio ? params : { lat: '', lng: '' })
    }
  }
}
</script>

<style scoped lang="less">
.store-content {
  .img-bc {
    position: relative;
    width: 65px;
    height: 65px;
    padding: 9px;
    background: url('~@/assets/images/u91.png') no-repeat;
    background-size: 65px 65px;
  }
  /deep/.van-cell {
    padding: 10px;
    .van-cell__title {
      padding-top: 20px;
      flex: none;
    }
    .van-cell__value {
      padding-left: 10px;
      text-align: left;
      color: #000;
    }
  }
}
.store-item-info {
  display: flex;
  padding: 10px;
  .store-img {
    width: 62px;
    height: 62px;
    object-fit: cover;
  }
  .custom-img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 53px;
    height: 53px;
    object-fit: cover;
  }
  .mark-img {
    position: absolute;
    bottom: 0;
    right: 4px;
    width: 24px;
    height: 30px;
    transform: rotate(-26deg);
  }
  .right-section {
    flex: 1;
    line-height: 20px;
    margin-left: 10px;
    .store-name {
      max-width: 261px;
      font-size: 16px;
      font-weight: bold;
    }
    .ba-name {
      max-width: 261px;
      font-size: 12px;
    }
    .product-type {
      display: flex;
      align-items: center;
      margin-top: 2px;
      font-size: 12px;
      .type-info {
        max-width: 251px;
        padding: 0px 3px;
        border: 1px solid #307bff;
        color: #307bff;
        border-radius: 3px;
      }
    }
    .basic-info {
      width: 276px;
      display: flex;
      align-items: center;
      margin-top: 5px;
      .city-name {
        max-width: 80px;
        padding: 0px 2px;
        background-color: #9d6600;
        color: #fff;
        font-size: 10px;
      }
      .address {
        // width: 186px;
        flex: 1;
        padding: 0 3px;
        font-size: 12px;
      }
      .nav-path-img {
        width: 18px;
        height: 18px;
      }
    }
  }
}
</style>
